module.exports = __webpack_public_path__ + "img/logo.9cade965.png";